import Cookies from 'js-cookie';
import { sortBy } from 'lodash';
import { apis } from '../configs';

export * from './route';
export * from './queries';
export * from './schema';
export * from './theme';
export * from './urlParams';
export * from './mobile';
export * from './mutationObserver';

const getStage = (host) => host
  .split('-')
  .reduce((acc, cur) => (
    cur.includes('stage')
      ? `${cur}-`
      : acc), '');

export const getApiUrl = (apiEndpoint, type) => {
  if (apiEndpoint) {
    return apiEndpoint;
  }
  if (window.location.host.includes('localhost') || ['8080', '8888', '6005'].includes(window.location.port)) {
    return `https://${apis[type].host}`;
  }
  // eslint-disable-next-line no-extra-boolean-cast
  if (Boolean(getStage(window.location.host))) {
    return `https://${getStage(window.location.host)}${apis[type].uri}`;
  }
  if (window.location.host.includes('preprod')) {
    return `https://preprod-${apis[type].uri}`;
  }
  return `https://${apis[type].uri}`;
};

export const isStandaloneProd = () => window.location.host.includes('project1content.com');

export const isMA = () => Boolean(Cookies.get('access_token_ma'));

export const getSortedOptions = (options, activeValue, value) => {
  if (options?.length) {
    return sortBy(options, (o) => !activeValue.includes(o.value?.toString() || o.id?.toString()))
      .map((opt) => ({ ...opt, value: opt.value || opt.id, label: opt.label || opt.name }))
      .filter((opt) => (value && opt.label.toLowerCase().includes(value.toLowerCase())) || !value);
  }
  return [];
};

export const mapOrder = (arr, ord, key) => arr.sort((a, b) => (ord.indexOf(a[key]) > ord.indexOf(b[key]) ? 1 : -1));
